"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const Definable_1 = __importDefault(require("./Definable"));
const state_1 = __importDefault(require("../state"));
const isRunningOnLocal_1 = __importDefault(require("../functions/isRunningOnLocal"));
const assetsAreLoaded_1 = __importDefault(require("../functions/assetsAreLoaded"));
class ImageSource extends Definable_1.default {
    constructor(slug) {
        super(slug);
        this._loader = new pixi_js_1.Loader;
        this._loader.add(this.getSRC()).load(() => {
            var _a, _b;
            state_1.default.loadedAssets++;
            if ((0, assetsAreLoaded_1.default)()) {
                (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("loading");
                (_b = document.getElementById("screen")) === null || _b === void 0 ? void 0 : _b.classList.add("focus");
            }
        });
    }
    get loader() {
        return this._loader;
    }
    getBaseTexture() {
        const texture = this._loader.resources[this.getSRC()].texture;
        if (typeof texture !== "undefined") {
            return texture.baseTexture;
        }
        throw new Error(`${this.constructor.name} "${this._slug}" Texture is not loaded.`);
    }
    getSRC() {
        if ((0, isRunningOnLocal_1.default)()) {
            return `./out/images/${this._slug}.png`;
        }
        return `./images/${this._slug}.png`;
    }
}
exports.default = ImageSource;
